import React, { useState, useCallback,useEffect, forwardRef, useImperativeHandle } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import {
GetOrderDetailGridData, GetArOpenItemGridData
    , GetItemMasterGridData
} from "../../../../services/SalesOrderService";
import OrderDetailResult from "../salesOrdersTab/OrderDetailResult";
import AROpenItemsResult from "../salesOrdersTab/AROpenItemsResult";
import ItemMasterResult from "../salesOrdersTab/ItemMasterResult";
import CustomerResult from "../salesOrdersTab/CustomerResult";
import CustomerContactResult from "../salesOrdersTab/CustomerContactResult";
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const AllOrdersTabs = forwardRef((props, ref) => {
    const orderStatus = '2';
    const orderDetailTab = 1;
    const arOpenItemsTab = 2;
    const itemMasterTab = 3;
    const customerTab = 4;
    const customerContactTab = 5;
    const getOrderDetailSearchUrl = "om/SaleOrder/OrderDetailSearch";
    const getArOpenItemshUrl = "om/SaleOrder/GetArOpenItems";
    const GetItemMasterDetailsUrl = "om/SaleOrder/GetItemMasterDetails";
    const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
    const GetCustomerConcatsUrl = "om/SaleOrder/GetCustomerConcats";
    const [orderDetailDataSource, setOrderDetailDataSource] = useState(null);
    const [arOpenItemsDataSource, setArOpenItemsDataSource] = useState(null);
    const [ItemMasterDataSource, setItemMasterDataSource] = useState(null);
    const [customerDataSource, setCustomerDataSource] = useState(null);
    const [customerContactDataSource, setCustomerContactDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [activeTab, setActiveTab] = useState(orderDetailTab);
    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
      }));
      const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const LoadTabsData = () => {
        if (selectedRow && selectedRow.rowid && activeTab === orderDetailTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, getOrderDetailSearchUrl, selectedRow.rowid);
            setOrderDetailDataSource(resultData);
        } else if (selectedRow && selectedRow.rCustomer && activeTab === arOpenItemsTab) {
            var resultData = GetArOpenItemGridData(props.accessToken, getArOpenItemshUrl, selectedRow.rCustomer);
            setArOpenItemsDataSource(resultData);
        } else if (activeTab === itemMasterTab) {
            var resultData = GetItemMasterGridData(props.accessToken, GetItemMasterDetailsUrl);
            setItemMasterDataSource(resultData);
        } else if (activeTab === customerTab) {
            var resultData = GetItemMasterGridData(props.accessToken, getCustomerListUrl);
            setCustomerDataSource(resultData);
        } else if (selectedRow && selectedRow.rCustomer && activeTab === customerContactTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, GetCustomerConcatsUrl, selectedRow.rCustomer);
            setCustomerContactDataSource(resultData);
        }
    };
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);
    return (
        <div>

            <div className="tab-bar">
                <div
                    className={`tab ${activeTab === orderDetailTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(orderDetailTab)}
                >
                    Order Detail
                </div>
                <div
                    className={`tab ${activeTab === arOpenItemsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(arOpenItemsTab)}
                >
                    AR Open Items
                </div>
                <div
                    className={`tab ${activeTab === itemMasterTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemMasterTab)}
                >
                    Item Master
                </div>
                <div
                    className={`tab ${activeTab === customerTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerTab)}
                >
                    Customer
                </div>
                <div
                    className={`tab ${activeTab === customerContactTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerContactTab)}
                >
                    Customer Contact
                </div>
            </div>
            {activeTab === orderDetailTab && (
                <OrderDetailResult data={orderDetailDataSource} />
            )}
            {activeTab === arOpenItemsTab && (
                <AROpenItemsResult data={arOpenItemsDataSource} />
            )}
            {activeTab === itemMasterTab && (
                <ItemMasterResult data={ItemMasterDataSource} />
            )}
            {activeTab === customerTab && (
                <CustomerResult data={customerDataSource} />
            )}
            {activeTab === customerContactTab && (
                <CustomerContactResult data={customerContactDataSource} />
            )}
        </div>
    );
});

export default AllOrdersTabs;